import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'location_block_reasons',
  inputShow: gql`
    query LocationBlockReasons($input: LocationBlockReasonQueryInput) {
      locationBlockReasons(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Location Block Reasons',
  },
};
